new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_list',
  data: {
    menuFilter: false,
    listOpened: false,
    listEx: localStorage.getItem('listOrder') ? localStorage.getItem('listOrder') : localStorage.setItem('listOrder', 0),
    listExMobile: localStorage.getItem('listOrderMobile') ? localStorage.getItem('listOrderMobile') : localStorage.setItem('listOrderMobile', 0)
  },
  methods: {
    filterPrice() {
      //chamadas para o filtro de preço
      function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#DADADA', '#000', controlSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromSlider.value = from;
        }
      }

      function controlToInput(toSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#DADADA', '#000', controlSlider);
        setToggleAccessible(toInput);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
        }
      }

      function controlFromSlider(fromSlider, toSlider, fromInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#DADADA', '#000', toSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromInput.value = from;
        }
      }

      function controlToSlider(fromSlider, toSlider, toInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#DADADA', '#000', toSlider);
        setToggleAccessible(toSlider);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
          toSlider.value = from;
        }
      }

      function getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [from, to];
      }

      function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
      }

      function setToggleAccessible(currentTarget) {
        const toSlider = document.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0) {
          toSlider.style.zIndex = 2;
        } else {
          toSlider.style.zIndex = 0;
        }
      }

      const fromSlider = document.querySelector('#fromSlider');
      const toSlider = document.querySelector('#toSlider');
      const fromInput = document.querySelector('#fromInput');
      const toInput = document.querySelector('#toInput');
      let url = window.location.href;
      
      if (url.includes('?lp=')) {
        const params = new URLSearchParams(window.location.search)
        const firstParams = params.get('lp');
        const secondParams = params.get('hp');
        fromInput.value = firstParams; 
        toInput.value = secondParams;
        fromSlider.setAttribute('value', firstParams);
        toSlider.setAttribute('value', secondParams);
        fillSlider(fromSlider, toSlider, '#DADADA', '#000', toSlider);
      } else {
        fillSlider(fromSlider, toSlider, '#DADADA', '#000', toSlider);
        setToggleAccessible(toSlider);
      }

      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
      fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
      toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

      function handleSliderRelease() {
        let from = $('#fromInput').val();
        let to = $('#toInput').val();
        window.location = `?lp=${from}&hp=${to}`;
      }

      $(fromSlider).mouseup(handleSliderRelease);
      $(fromSlider).on('touchend', handleSliderRelease);

      $(toSlider).mouseup(handleSliderRelease);
      $(toSlider).on('touchend', handleSliderRelease);
    },
    changeList(list) {
      this.listEx = list;
      localStorage.setItem('listOrder', list);
    },

    changeListMobile(list) {
      this.listExMobile = list;
      this.listOpened = false;
      localStorage.setItem('listOrderMobile', list);
    }
  },
  mounted() {
    this.filterPrice()
  },
});